import * as React from "react";

const CopyContentIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={23} height={26.632} {...props}>
    <path
      data-name="Icon material-content-copy"
      d="M16.947 0H2.421A2.428 2.428 0 0 0 0 2.421v16.947h2.421V2.421h14.526Zm3.632 4.842H7.263a2.428 2.428 0 0 0-2.421 2.421v16.948a2.428 2.428 0 0 0 2.421 2.421h13.316A2.428 2.428 0 0 0 23 24.211V7.263a2.428 2.428 0 0 0-2.421-2.421Zm0 19.368H7.263V7.263h13.316Z"
      fill="#00C4DE"
    />
  </svg>
);

export default CopyContentIcon;
